const isLoading = false;

const reducer = (state = isLoading, action) => {
  switch (action.type) {
    case 'is_loading':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
